// import React from 'react';
import React from 'react';
import '../../styles/HomeComponents/GettingStarted.css';
import welcomeImage from '../../assets/Images/MaskGroup - Copy.webp'; // Update this path if needed

const GettingStarted = () => {
  const handleClick = () => {
    const tidycalUrl = process.env.REACT_APP_TIDYCAL_URL;

    try {
      // OPEN IN SAME TAB — REQUIRED FOR REDIRECT TO WORK
      window.location.href = tidycalUrl;
    } catch (error) {
      console.error('Error opening TidyCal booking page:', error);
      alert('An error occurred while trying to open the booking page. Please try again later.');
    }
  };


  return (
    <section className="getting-started-container">
      <div className="getting-started-content">
        <h2>Getting started with Strawket today!</h2>
        <p>
          Strawket eliminates administrative headaches while creating <br /> transformative learning experiences-letting passion and talent flourish.
        </p>
        <button onClick={handleClick} className="getting-started-button">Get Started</button>
      </div>
      <div className="getting-started-image">
        <img src={welcomeImage} alt="Strawket Dashboard" />
      </div>
    </section>
  );
};

export default GettingStarted;
